module.exports = __webpack_public_path__ + "img/torre-eiffel-pexels1.00e3c07d.jpg";